<template>
  <div class="questionnaire">
    <div style="height: 40px"></div>
    <el-card class="card">
      <div class="title">
        <div class="name">德阳智慧招投标综合服务监管系统</div>
        <div>我们承诺，对您所提供的有关内容严格保密</div>
      </div>
      <el-form
        :model="row"
        :rules="rules"
        ref="ruleForm"
        class="demo-form-inline"
      >
        <el-form-item label="举报标题" prop="title" label-width="110px">
          <el-input
            v-model="row.title"
            placeholder="举报标题"
            style="width: 350px"
          ></el-input>
        </el-form-item>

        <el-form-item label="举报人手机号" prop="phone" label-width="110px">
          <el-input
            v-model="row.phone"
            placeholder="举报人手机号"
            style="width: 350px"
          ></el-input>
        </el-form-item>

        <el-form-item
          label="问题项目名称"
          prop="projectName"
          label-width="110px"
        >
          <el-input
            v-model="row.projectName"
            placeholder="问题项目名称"
            style="width: 350px"
          ></el-input>
        </el-form-item>

        <el-form-item label="标段名称" prop="lotName" label-width="110px">
          <el-input
            v-model="row.lotName"
            placeholder="标段名称"
            style="width: 350px"
          ></el-input>
        </el-form-item>

        <el-form-item label="问题企业名称" prop="qyName" label-width="110px">
          <el-input
            v-model="row.qyName"
            placeholder="问题企业名称"
            style="width: 350px"
          ></el-input>
        </el-form-item>
        <el-form-item label="日期" prop="reportTime" label-width="110px">
          <el-date-picker
            v-model="row.reportTime"
            value-format="yyyy-MM-dd"
            type="date"
            placeholder="选择日期"
            style="width: 350px"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item label="验证码" prop="code" label-width="110px">
          <div class="bind_code margin_top">
            <el-input
              class="bind_code_input code"
              v-model="row.code"
              type="text"
              placeholder="请输入验证码"
            />
            <el-button
              @click.native.prevent="bindforgetSendCode"
              class="bind_code_gain"
              >8858</el-button
            >
          </div>
        </el-form-item>
        <el-form-item label="举报内容" prop="content" label-width="110px">
          <el-input
            v-model="row.content"
            placeholder="请输入举报内容"
            style="width: 350px"
          ></el-input>
        </el-form-item>
        <el-form-item
          label="上传材料"
          prop="materialAddress"
          label-width="110px"
        >
          <el-upload
            class="upload-demo"
            action="http://129.211.214.215:9091/common/upload"
            :on-change="handleChange"
            :file-list="fileList"
          >
            <el-button size="small" type="primary">点击上传</el-button>
          </el-upload>
        </el-form-item>

        <el-form-item prop="resource" style="margin-left: 40px">
          <el-radio-group v-model="row.isAnonymous">
            <el-radio :label="1">匿名</el-radio>
            <el-radio :label="2">实名</el-radio>
          </el-radio-group>
        </el-form-item>

        <div v-if="row.isAnonymous == 2">
          <el-form-item label="姓名" prop="reportName" label-width="110px">
            <el-input
              v-model="row.reportName"
              placeholder="姓名"
              style="width: 350px"
            ></el-input>
          </el-form-item>

          <el-form-item label="所在单位" prop="reportUnit" label-width="110px">
            <el-input
              v-model="row.reportUnit"
              placeholder="所在单位"
              style="width: 350px"
            ></el-input>
          </el-form-item>

          <el-form-item
            label="身份证号"
            prop="reportIdcard"
            label-width="110px"
          >
            <el-input
              v-model="row.reportIdcard"
              placeholder="身份证号"
              style="width: 350px"
            ></el-input>
          </el-form-item>
        </div>

        <el-form-item style="margin-left: 40%">
          <el-button type="primary" @click="submitForm('ruleForm')"
            >立即提交</el-button
          >
        </el-form-item>
      </el-form>
    </el-card>
    <div class="footer">举报电话：13881080402</div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      row: {
        isAnonymous: 2,
      },
      fileList: [],
      rules: {
        title: [{ required: true, message: "请输入举报标题", trigger: "blur" }],
        phone: [
          { required: true, message: "请输入举报人手机号", trigger: "blur" },
        ],
        projectName: [
          { required: true, message: "请输入问题项目名称", trigger: "blur" },
        ],
        lotName: [
          { required: true, message: "请输入标段名称", trigger: "blur" },
        ],
        qyName: [
          { required: true, message: "请输入问题企业名称", trigger: "blur" },
        ],
        reportTime: [
          { required: true, message: "请输入日期", trigger: "blur" },
        ],
        code: [{ required: true, message: "请输入验证码", trigger: "blur" }],
        content: [
          { required: true, message: "请输入举报内容", trigger: "blur" },
        ],
        reportName: [
          { required: true, message: "请输入姓名", trigger: "blur" },
        ],
        reportUnit: [
          { required: true, message: "请输入所在单位", trigger: "blur" },
        ],
        reportIdcard: [
          { required: true, message: "请输入身份证号", trigger: "blur" },
        ],
      },
    };
  },
  methods: {
    submitForm() {
      if (this.fileList.length == 0) {
        this.$message.error("请上传材料");
        return;
      }

      this.$refs.ruleForm.validate(async (valid) => {
        if (valid) {
          this.row.materialAddress = this.fileList[0].response.fileName;
          const { data: res } = await this.$http.post(
            `report/report/submit`,
            this.row
          );
          if (res.code == 200) {
            this.$message.success("收到您的举报，我们将尽快核实！");
            setTimeout(() => {
              window.location.href = "https://gzzc.sczyzx.cn/";
            },2000)
          }
        }
      });
    },
    handleChange(file, fileList) {
      this.fileList = fileList.slice(-3);
    },
  },
};
</script>

<style lang="scss">
.questionnaire {
  width: 100%;

  .footer{
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 40px;
    color: #999;
    -webkit-user-select:none;
     -moz-user-select:none;
     -ms-user-select:none;
     user-select:none;
  }
  .card {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width: 1000px;
    height: 100%;
    margin: 0 auto 10px;
    .title {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      width: 100%;
      color: #666;
      margin-bottom: 30px;
      .name {
        font-size: 24px;
        font-weight: bold;
        margin-bottom: 10px;
      }
    }
    .bind_code {
      width: 350px;
      position: relative;
      .el-input__inner {
        width: 350px;
        height: 44px;
        background: #fff;
        border-radius: 4px;
        border: 1px solid #e4e4e4;
        outline: none;
        padding: 0 100px 0 10px;
      }

      .code .el-input__suffix {
        right: 97px;
      }
      .el-button {
        border: 0;
        background: none;
        padding: 0;
        border-radius: 0;
      }
      .pic {
        width: 80px;
        height: 25px;
        border-left: none !important;
      }
      .bind_code_gain {
        position: absolute;
        top: calc(50% - 9px);
        right: 10px;
        font-size: 14px;
        font-family: MicrosoftYaHei;
        color: #20aee5;
        line-height: 18px;
        cursor: pointer;
        padding-left: 10px;
        border-left: 1px solid #d8d8d8;
      }
    }
  }
}
</style>